import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "menu" ]
  static values = { users: Array }

  connect() {
    this.activeIndex = 0
    this.matches = []
    this.hide()
  }

  suggest() {
    const match = this.queryMatch()
    if (!match) {
      this.hide()
      return
    }

    const query = match.query.toLowerCase()
    this.matches = this.usersValue.filter((user) => {
      const username = (user.username || "").toLowerCase()
      const name = (user.name || "").toLowerCase()
      return username.startsWith(query) || name.includes(query)
    }).slice(0, 8)

    if (this.matches.length === 0) {
      this.hide()
      return
    }

    this.activeIndex = 0
    this.render()
    this.show()
  }

  keydown(event) {
    if (this.menuOpen) {
      if (event.key === "ArrowDown") {
        event.preventDefault()
        this.move(1)
      } else if (event.key === "ArrowUp") {
        event.preventDefault()
        this.move(-1)
      } else if (event.key === "Enter" || event.key === "Tab") {
        event.preventDefault()
        this.pick(this.activeIndex)
      } else if (event.key === "Escape") {
        event.preventDefault()
        this.hide()
      }
      return
    }

    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }

  submitOnEnter(event) {
    if (this.menuOpen || event.shiftKey) return

    event.preventDefault()
    this.element.requestSubmit()
  }

  pick(index = this.activeIndex) {
    const user = this.matches[index]
    const match = this.queryMatch()
    if (!user || !match) return

    const field = this.inputTarget
    const before = field.value.slice(0, match.start)
    const after = field.value.slice(this.caret)
    field.value = `${before}@${user.username} ${after}`
    const caret = `${before}@${user.username} `.length
    field.focus()
    field.setSelectionRange(caret, caret)
    this.hide()
    field.dispatchEvent(new Event("input", { bubbles: true }))
  }

  queryMatch() {
    const field = this.inputTarget
    this.caret = field.selectionStart
    const text = field.value.slice(0, this.caret)
    const match = text.match(/(^|[^a-z0-9_])@([a-z0-9_-]*)$/i)
    if (!match) return null

    return { query: match[2], start: match.index + match[1].length }
  }

  render() {
    this.menuTarget.innerHTML = this.matches.map((user, index) => {
      const active = index === this.activeIndex ? " active" : ""
      return `<button type="button" class="nw-mention-menu__item${active}" role="option" data-action="mousedown->mention#choose" data-mention-index-param="${index}"><span class="fw-medium">@${this.escape(user.username)}</span><span class="text-muted small">${this.escape(user.name)}</span></button>`
    }).join("")
  }

  choose(event) {
    event.preventDefault()
    this.pick(Number(event.params.index))
  }

  move(step) {
    if (this.matches.length === 0) return

    this.activeIndex = (this.activeIndex + step + this.matches.length) % this.matches.length
    this.render()
  }

  show() {
    this.menuTarget.classList.remove("d-none")
    this.menuTarget.hidden = false
  }

  hide() {
    this.menuTarget.classList.add("d-none")
    this.menuTarget.hidden = true
    this.menuTarget.innerHTML = ""
    this.matches = []
  }

  get menuOpen() {
    return !this.menuTarget.hidden && this.matches.length > 0
  }

  escape(value) {
    return String(value || "").replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }[char]))
  }
}
